// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3O1Tn","colBig":"styles_colBig__23icX","colSmall":"styles_colSmall__MQfSR","shopifyNameWrapper":"styles_shopifyNameWrapper__1gfs1"};